export default __webpack_public_path__ + "static/media/Upload.14685d2b.svg";